import Vue from 'vue'

// 全局混入
Vue.mixin({
  data () {
    return {

    }
  },
  methods: {
    // 跳转
    Jump (url, query, type) {
      if (url && typeof url === 'string') {
        if (type === 'replace') {
          this.$router.replace({
            path: url,
            query: query || {}
          })
        } else {
          this.$router.push({
            path: url,
            query: query || {}
          })
        }
      }
    },

    // 后退上一页
    Back () {
      this.$router.go(-1)
    },

    // 去首页
    Home () {
      this.$router.replace({
        path: '/home'
      })
    },

    // 格式html标签乱码
    analysisTextGarbled (str) {
      str = str || ''
      str = str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;nbsp;/g, ' ')
      return str
    }

  }
})
